import { Model } from 'vuex-orm';

import User from '../user/model';
import Category from '../category/model';

export default class PtoAvailability extends Model {
  static entity = 'ptoAvailabilities';

  static fields() {
    return {
      id: this.attr(null),
      user_id: this.attr(null),
      author_id: this.attr(null),
      category_id: this.attr(null),
      year: this.attr(''),
      total: this.attr(''),
      created_at: this.attr(''),
      updated_at: this.attr(''),

      user: this.belongsTo(User, 'user_id'),
      author: this.belongsTo(User, 'author_id'),
      category: this.belongsTo(Category, 'category_id'),
    };
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/ptoAvailability/model.js